import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LandingPage } from './pages/LandingPage'
import { ImageGenerator } from './pages/ImageGenerator'
import { HistoryPage } from './pages/HistoryPage'
import { TTSPPage } from './pages/TTSPPage'
import { AuthPage } from './pages/AuthPage'
import { UserSettings } from './pages/UserSettings'
import { AdminDashboard } from './pages/AdminDashboard'
import { DirectorPage } from './pages/DirectorPage'
import { DirectorPageV2 } from './pages/DirectorPageV2'
import { PromptCraftPage } from './pages/PromptCraftPage'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { TermsOfService } from './pages/TermsOfService'
import { ImageGeneratorPreview } from './pages/ImageGeneratorPreview'
import { HistoryPagePreview } from './pages/HistoryPagePreview'
import { CanvasPage } from './pages/CanvasPage'
import { CanvasListPage } from './pages/CanvasListPage'
import { ProtectedRoute } from './components/ProtectedRoute'
import { PublicOrProtectedRoute } from './components/PublicOrProtectedRoute'
import { LanguageProvider } from './i18n/LanguageContext'
import './App.css'

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />

        {/* 主要功能页面 - 支持公开预览 */}
        <Route
          path="/imagen"
          element={
            <PublicOrProtectedRoute
              publicComponent={ImageGeneratorPreview}
              protectedComponent={ImageGenerator}
              requireAuth={true}
            />
          }
        />
        <Route
          path="/history"
          element={
            <PublicOrProtectedRoute
              publicComponent={HistoryPagePreview}
              protectedComponent={HistoryPage}
              requireAuth={true}
            />
          }
        />

        {/* 其他受保护的路由 */}
        <Route
          path="/tts"
          element={
            <ProtectedRoute>
              <TTSPPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/director"
          element={
            <ProtectedRoute>
              <DirectorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/director_v2"
          element={
            <ProtectedRoute>
              <DirectorPageV2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/promptcraft"
          element={
            <ProtectedRoute>
              <PromptCraftPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/canvas"
          element={
            <ProtectedRoute>
              <CanvasPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/canvases"
          element={
            <ProtectedRoute>
              <CanvasListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserSettings />
            </ProtectedRoute>
          }
        />

        {/* 管理员专用路由 */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        </Routes>
      </Router>
    </LanguageProvider>
  )
}

export default App
